var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "preview_wrapper",
    class: {
      has_actions: _vm.hasActions,
      full_height: _vm.isFullHeight
    }
  }, [_vm._t("actions", function () {
    return [_c('div', {
      staticClass: "c-flex",
      staticStyle: {
        "position": "absolute",
        "top": "0",
        "left": "0",
        "transform": "translate(-50%, -50%)",
        "z-index": "10",
        "gap": "0.5rem"
      }
    }, [_vm.allowClear && !_vm.showNoPreviewMessage ? _c('div', [_c('ButtonMiniAction', {
      staticClass: "action_btn",
      attrs: {
        "tooltip": "Clear file selection",
        "tooltip-position": "bottom left"
      },
      on: {
        "click": _vm.emitClear
      }
    }, [[_c('c-icon-fa', {
      attrs: {
        "icon": "fad fa-times-circle",
        "icon-color": "var(--v-secondary-base)"
      }
    })]], 2)], 1) : _vm._e()]), _c('div', {
      staticClass: "c-flex",
      staticStyle: {
        "position": "absolute",
        "top": "8px",
        "right": "8px",
        "z-index": "10"
      }
    }, [_vm.showDownload && _vm.file ? _c('div', [_c('ButtonMiniAction', {
      staticClass: "gray_circle_btn",
      attrs: {
        "tooltip": "Download file",
        "tooltip-position": "bottom left"
      },
      nativeOn: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.triggerDownload.apply(null, arguments);
        }
      }
    }, [[_c('c-icon-fa', {
      attrs: {
        "icon": "fad fa-download",
        "icon-color": "white"
      }
    })]], 2)], 1) : _vm._e()])];
  }), _vm._t("img_preview", function () {
    return [_c('v-slide-y-transition', {
      attrs: {
        "hide-on-leave": ""
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isImage,
        expression: "isImage"
      }],
      staticClass: "img_wrapper c-flex"
    }, [_c('img', {
      ref: "img_preview",
      style: {
        height: _vm.computedImgHeight,
        width: _vm.computedImgWidth
      },
      attrs: {
        "id": "img_preview"
      },
      on: {
        "load": _vm.emitPreviewLoaded
      }
    })])])];
  }), _vm._t("video_preview", function () {
    return [_c('v-slide-y-transition', {
      attrs: {
        "hide-on-leave": ""
      }
    }, [_c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isVideo,
        expression: "isVideo"
      }],
      attrs: {
        "xs12": ""
      }
    }, [_vm.videoPreviewUrl && _vm.videoPreviewType ? _c('video', {
      ref: "video_preview_player",
      style: {
        width: _vm.computedVideoWidth,
        height: _vm.computedVideoHeight
      },
      attrs: {
        "controls": "",
        "id": "video_preview_player",
        "width": "640",
        "height": "480"
      },
      on: {
        "load": _vm.emitPreviewLoaded
      }
    }, [_c('source', {
      ref: "video_preview_source",
      attrs: {
        "src": _vm.videoPreviewUrl,
        "type": _vm.videoPreviewType,
        "id": "video_preview_source"
      }
    }), _vm._v(" Your browser does not support HTML5 video. ")]) : _vm._e()])], 1)];
  }), _vm._t("pdf_preview", function () {
    return [_c('v-slide-y-transition', {
      attrs: {
        "hide-on-leave": ""
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isPdf,
        expression: "isPdf"
      }],
      staticClass: "pdf-preview-container"
    }, [_c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isPdf,
        expression: "isPdf"
      }],
      staticClass: "pdf_wrapper",
      style: {
        full_height: _vm.isFullHeight,
        height: _vm.computedPdfHeight,
        overflow: _vm.overflowHidden ? 'hidden' : 'visible'
      },
      attrs: {
        "xs12": ""
      }
    }, [_vm.pdfPreviewUrl ? _c('embed', {
      ref: "pdf_preview",
      staticClass: "pdf_preview",
      style: {
        width: _vm.computedPdfWidth,
        height: _vm.computedPdfHeight
      },
      attrs: {
        "src": _vm.pdfPreviewUrl,
        "type": _vm.contentType || undefined,
        "id": "pdf_preview",
        "width": "640"
      },
      on: {
        "load": _vm.emitPreviewLoaded
      }
    }) : _vm._e()])], 1)])];
  }), _vm._t("after_previews"), _c('v-slide-y-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_vm.showNoPreviewMessage ? _c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "xs12": ""
    }
  }, [_vm._t("no_preview", function () {
    return [_vm.isMicrosoftOffice ? _c('div', {
      staticClass: "mb-3",
      staticStyle: {
        "position": "relative",
        "display": "inline-block"
      }
    }, [_c('c-icon-fa', {
      attrs: {
        "icon": "fab fa-microsoft",
        "icon-size": "64px",
        "icon-color": "#737373"
      }
    }), _c('c-icon-fa', {
      staticStyle: {
        "position": "absolute",
        "bottom": "-5px",
        "right": "-10px",
        "background": "white",
        "border-radius": "50%"
      },
      attrs: {
        "icon": "fas fa-question-circle",
        "icon-size": "28px",
        "icon-color": "var(--v-warning-base)"
      }
    })], 1) : _vm._e(), _vm.isMicrosoftOffice ? _c('AppPageDescription', {
      attrs: {
        "remove-margin-left": "",
        "color": "warning"
      }
    }, [_vm._v("Microsoft Office files are currently unavailable for preview. "), _c('br'), _vm._v(" You can "), _c('a', {
      attrs: {
        "href": _vm.downloadUrlForLogging,
        "download": "",
        "title": "Download file"
      },
      on: {
        "click": _vm.logDownload
      }
    }, [_vm._v("download the file")]), _vm._v(" and open with Microsoft Office or convert to PDF for in browser viewing. ")]) : _c('AppPageDescription', {
      attrs: {
        "remove-margin-left": "",
        "color": "warning"
      }
    }, [_vm._v(" No preview available. ")]), _vm.isMicrosoftOffice ? _c('div', [_c('AppPageDescription', {
      staticClass: "mb-2",
      attrs: {
        "remove-margin-left": "",
        "color": "info"
      }
    }, [_vm._v("How to convert to PDF using Microsoft Office")]), _c('ol', {
      staticClass: "ml-2",
      staticStyle: {
        "text-align": "left",
        "display": "inline-block"
      }
    }, [_c('li', [_vm._v("Select "), _c('b', [_vm._v("File")]), _vm._v(" tab")]), _c('li', [_vm._v("Select "), _c('b', [_vm._v("Save As")]), _vm._v(".")]), _c('li', [_vm._v("In the "), _c('b', [_vm._v("File Name")]), _vm._v(" box, enter a name for the file, if you haven't already.")]), _c('li', [_vm._v("In the "), _c('b', [_vm._v("Save as type")]), _vm._v(" list, select "), _c('b', [_vm._v("PDF (*.pdf)")]), _vm._v(".")]), _c('li', [_vm._v("Select "), _c('b', [_vm._v("Save")]), _vm._v(".")])])], 1) : _vm._e()];
  })], 2) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };